module.exports = __webpack_public_path__ + "img/Q2-image.c7743b64.png";